import React, { useEffect, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import query from "./query";
import SearchResult from "./searchResult";
import fetch from "../../fetch";
import Loading from "components/loading";
import Error from "components/error";
import NotFound from "components/not-found";
import Seo from "components/seo";
import { ReactComponent as SearchIcon } from "../../assets/search_icon.svg";

import { AppContext } from "appContext";

import styles from "./search.module.scss";

const Search = ({ match }) => {
  const { search } = useLocation();
  const initialKeyword = new URLSearchParams(search).get("q") || "";

  const [searchKeyWord, setSearchKeyword] = useState(initialKeyword || null);
  const [searchVal, setSearchVal] = useState(initialKeyword);
  const [autoFocus, setAutoFocus] = useState(false);

  const uri = match.url.replace("/", "");
  const { data, loading, error } = fetch(query, uri);

  const navigationContext = useContext(AppContext);

  useEffect(() => {
    navigationContext.setIsReport(false);
  }, [data, navigationContext]);

  if (loading) {
    return <Loading />;
  }

  if (error && !data) {
    console.log(error);
    return <Error />;
  }

  if (!data.entry) {
    return <NotFound />;
  }

  const SearchForm = ({ placeholder }) => {
    const handleSearchSubmit = (e) => {
      e.preventDefault();
      const value = e.target[0].value;
      setSearchKeyword(value);

      if (typeof window !== "undefined") {
        const encoded = value ? `?q=${encodeURIComponent(value)}` : "/search";
        window.history.replaceState(null, null, encoded);
      }
    };

    const handleSearchChange = (e) => {
      e.preventDefault();
      setSearchVal(e.target.value);
      setAutoFocus(true);
    };

    return (
      <div>
        <form
          action="/search"
          className={styles.searchForm}
          onSubmit={handleSearchSubmit}
        >
          <input
            aria-label="search input"
            className={styles.searchInput}
            type="search"
            placeholder={placeholder}
            value={searchVal}
            autoFocus={autoFocus}
            onChange={handleSearchChange}
          />
          <button
            className={styles.searchBtn}
            aria-label="search submit"
            type="submit"
          >
            <SearchIcon />
          </button>
        </form>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Seo seomaticData={data.seomatic} />
      <div className={styles.searchPageWrapper}>
        <h1>{data.entry.heading ? data.entry.heading : "Search"}</h1>
        <SearchForm
          placeholder={
            data.entry.plainText ? data.entry.plainText : "Search keywords here"
          }
        />

        <SearchResult
          searchValue={searchKeyWord}
          noResultsText={
            data.entry.body
              ? data.entry.body
              : "Sorry! No results found, try searching a different keyword."
          }
          siteMapText={data.entry.introBody}
          siteMapTextNoResults={data.entry.subheader}
          siteMap={data.entry.siteMap}
        />
      </div>
    </React.Fragment>
  );
};

export default Search;
